// extracted by mini-css-extract-plugin
export default {"name":"Header_name__JuRPK","header":"Header_header__OA0rS","memberSince":"Header_memberSince__AYu3U"};